import invariant from 'invariant';
import querystring from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getDetailsByPartNumbers(params) {
    let { baseUrl, brandId, country, partNumbers, options, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getDetailsByPartNumbers()');
    invariant(brandId, 'brandId is a required param of getDetailsByPartNumbers()');
    invariant(country, 'country is a required param of getDetailsByPartNumbers()');
    invariant(partNumbers, 'partNumbers is a required param of getDetailsByPartNumbers()');
    invariant(clientId, 'clientId is a required param of getDetailsByPartNumbers()');

    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const partNumbersQuery = partNumbers ? partNumbers.map((partNumber) => `pn=${partNumber}`).join('&') : '';
    const optionalQuery = options ? `&${querystring.stringify(options)}` : '';

    const concatUrl = `${baseUrl}search/resources/store/${localisedBrand}/productview/summary/byPartNumbers?${partNumbersQuery}${optionalQuery}`;
    return labelRequest(authenticatedRequest(new Request(concatUrl), uberToken, clientId, clientSecret), 'getDetailsByPartNumbers');
}
